export default "__VITE_ASSET__Cdw7lZpC__"